// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"Form_mainCont__qXEjD","formContainer":"Form_formContainer__2nU3b","dietsBoxes":"Form_dietsBoxes__2xZdH"};